import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "reports-menu-root bc-2" }
const _hoisted_2 = { class: "resolution-selector-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "actions"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_5 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resolution_selector = _resolveComponent("resolution-selector")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_time_seeker = _resolveComponent("time-seeker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "left"),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showResolution)
        ? (_openBlock(), _createBlock(_component_resolution_selector, {
            key: 0,
            modelValue: _ctx.resolution,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.resolution) = $event)),
            class: "hide-sp"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showAdminBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/admin/menu",
            class: "actions-item"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isShowSummary ? 'show-summary' : '', "calendar-controller"])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_date_picker, {
          modelValue: _ctx.targetDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetDate) = $event)),
          resolution: _ctx.resolution
        }, null, 8, ["modelValue", "resolution"])
      ]),
      _createVNode(_component_time_seeker, {
        onPrev: _ctx.movePrev,
        onToday: _ctx.moveToday,
        onNext: _ctx.moveNext,
        resolution: _ctx.resolution
      }, null, 8, ["onPrev", "onToday", "onNext", "resolution"]),
      (_ctx.showResolution && ['day', 'month'].includes(_ctx.resolution))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showSummary && _ctx.showSummary(...args))),
            class: "btn-change-summary show hide-pc"
          }, " 集計値 "))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideSummary && _ctx.hideSummary(...args))),
        class: "btn-change-summary back hide-pc"
      }, "戻る")
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}